/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ReactNode } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports
import { css, jsx } from '@emotion/react';
import { type IntlShape, injectIntl } from 'react-intl';
import type { LoadingComponentProps } from 'react-loadable';

import { messages } from '@atlaskit/editor-common/extensions/messages';
import SectionMessage from '@atlaskit/section-message/message';
import Spinner from '@atlaskit/spinner/spinner';
import { token } from '@atlaskit/tokens';

const spinnerWrapperStyles = css({
	display: 'flex',
	justifyContent: 'center',
	marginTop: token('space.800'),
});

const errorWrapperStyles = css({
	marginTop: token('space.400'), // Add some padding to the top to make sure we place this below the offline status banner
});

const LoadingStateWithErrorHandling = injectIntl(
	(props: Partial<LoadingComponentProps> & { intl: IntlShape }) => {
		if (props.error) {
			return (
				<div css={errorWrapperStyles} data-testid="ConfigPanelLoadingError">
					<SectionMessage appearance="error">
						{props.intl.formatMessage(messages.panelLoadingError)}
					</SectionMessage>
				</div>
			);
		}
		return (
			<div css={spinnerWrapperStyles} data-testid="ConfigPanelLoading">
				<Spinner size="small" interactionName="config-panel-spinner" />
			</div>
		);
	},
);

const LoadingState = (
	props: Partial<LoadingComponentProps>,
): string | number | boolean | jsx.JSX.Element | Iterable<ReactNode> | null | undefined =>
	LoadingStateWithErrorHandling(props);

export default LoadingState;
